import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useApplication, InputSourceModes } from '../../../model/context/applicationContext';
import { ApplicationNumberInput } from '../inputBlock/applicationNumberInput';
import DragDropFile from '../../xml/xmlDragDrop';

export const InputSourceBar = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { applicationNumber, applicationSource, resetApplication } = useApplication();

  const [mode, setMode] = useState<InputSourceModes>(applicationSource || 'Dploy');
  const [applicationNumberInputValue, setApplicationNumberInputValue] = useState(
    applicationSource === 'Dploy' ? applicationNumber : ''
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{
        height: 40,
        px: 2.5,
        flexShrink: 0,
        bgcolor: '#FAFAF8',
        borderBottom: 1,
        borderColor: 'divider'
      }}>
      <Typography variant="body2" color="text.secondary">
        {intl.formatMessage({ id: 'InputSource' })}
      </Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={mode}
        onChange={(_, value: InputSourceModes | null) => value && setMode(value)}
        sx={{
          '& .MuiToggleButton-root': { py: 0.25, px: 1.25, textTransform: 'none' },
          '& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover': {
            bgcolor: 'primary.main',
            color: '#fff'
          }
        }}>
        <ToggleButton value="Local">{intl.formatMessage({ id: 'Local' })}</ToggleButton>
        <ToggleButton value="Dploy">{intl.formatMessage({ id: 'Dploy' })}</ToggleButton>
      </ToggleButtonGroup>
      {mode === 'Local' ? (
        <DragDropFile />
      ) : (
        <Box sx={{ '& .MuiFormControl-root': { mt: 0, width: 240 } }}>
          <ApplicationNumberInput
            inputValue={applicationNumberInputValue}
            setInputValue={setApplicationNumberInputValue}
          />
        </Box>
      )}
      <Stack direction="row" alignItems="center" spacing={0.75}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: applicationNumber ? 'success.main' : 'grey.400'
          }}
        />
        <Typography variant="body2" color="text.secondary">
          {applicationNumber
            ? `${applicationSource} · ${intl.formatMessage({ id: 'ApplicationNumber' })} ${applicationNumber}`
            : 'No input loaded'}
        </Typography>
      </Stack>
      <Button variant="text" onClick={() => navigate('/xml')}>
        {intl.formatMessage({ id: 'Xml' })}
      </Button>
      <Button
        variant="text"
        color="inherit"
        onClick={() => {
          resetApplication();
          setApplicationNumberInputValue('');
        }}>
        {intl.formatMessage({ id: 'ClearInputSource' })}
      </Button>
    </Stack>
  );
};
